import {
    STORAGE_KEY_DYNAMIC_USER_ID,
    STORAGE_KEY_DYNAMIC_CLICK_ID,
    STORAGE_KEY_DYNAMIC_USER_LAST_EBON_INFO_ID,
    STORAGE_KEY_DYNAMIC_SCORE_HASH,
    STORAGE_KEY_DYNAMIC_REDIRECTION,
    STORAGE_KEY_DYNAMIC_SOURCE,
    STORAGE_KEY_FAILURE_BANK_TRANSFER_ENABLED
} from '../constants/storage';
import { API_ROOT } from '../constants';

import {
    catchUserLastEbonInfo,
    clearExpiredSessionStorageKey,
    getStorageKey
} from './storageUtils';
import { nowTimestampPlusDays } from './dateUtils';

export const getUserId = () => {
    const storageKeyUserId = getStorageKey(STORAGE_KEY_DYNAMIC_USER_ID);
    const dynamicUserIdStored = sessionStorage.getItem(storageKeyUserId)
        ? JSON.parse(sessionStorage.getItem(storageKeyUserId))
        : {};
    return dynamicUserIdStored.userId ? dynamicUserIdStored.userId : null;
};

export const getClickId = () => {
    const storageKeyClickId = getStorageKey(STORAGE_KEY_DYNAMIC_CLICK_ID);
    const dynamicClickIdStored = sessionStorage.getItem(storageKeyClickId)
        ? JSON.parse(sessionStorage.getItem(storageKeyClickId))
        : {};
    return dynamicClickIdStored.clickId ? dynamicClickIdStored.clickId : null;
};

export const getLastUserInfoStored = () => {
    const storageUserLastEbonInfoKey = getStorageKey(STORAGE_KEY_DYNAMIC_USER_LAST_EBON_INFO_ID);
    const dynamicUserLastEbonInfoStored = sessionStorage.getItem(storageUserLastEbonInfoKey)
        ? JSON.parse(sessionStorage.getItem(storageUserLastEbonInfoKey))
        : {};
    return dynamicUserLastEbonInfoStored ? dynamicUserLastEbonInfoStored : null;
};

export const getFraudScore = () => {
    const storageKeyScoreHash = getStorageKey(STORAGE_KEY_DYNAMIC_SCORE_HASH);
    const dynamicScoreHashStored = sessionStorage.getItem(storageKeyScoreHash)
        ? JSON.parse(sessionStorage.getItem(storageKeyScoreHash))
        : {};
    return dynamicScoreHashStored.score ? dynamicScoreHashStored.score : null;
};

export const getHash = () => {
    const storageKeyScoreHash = getStorageKey(STORAGE_KEY_DYNAMIC_SCORE_HASH);
    const dynamicScoreHashStored = sessionStorage.getItem(storageKeyScoreHash)
        ? JSON.parse(sessionStorage.getItem(storageKeyScoreHash))
        : {};
    return dynamicScoreHashStored.hash ? dynamicScoreHashStored.hash : null;
};

export const getConfirmRedirection = () => {
    const storageKeyRedirection = getStorageKey(STORAGE_KEY_DYNAMIC_REDIRECTION);
    const dynamicRedirectionStored = sessionStorage.getItem(storageKeyRedirection)
        ? JSON.parse(sessionStorage.getItem(storageKeyRedirection))
        : {};
    return dynamicRedirectionStored.redirectUri ? dynamicRedirectionStored : null;
};

export const catchRedirectUri = (redirectUri, label) => {
    const storageKey = getStorageKey(STORAGE_KEY_DYNAMIC_REDIRECTION);
    clearExpiredSessionStorageKey(storageKey);

    if (redirectUri) {
        const dynamicRedirectionUpdated = {};
        dynamicRedirectionUpdated.redirectUri = redirectUri ? redirectUri : '';
        dynamicRedirectionUpdated.label = label ? label.substr(0, 100) : '';
        dynamicRedirectionUpdated.expiration = nowTimestampPlusDays(1);

        sessionStorage.setItem(storageKey, JSON.stringify(dynamicRedirectionUpdated));
    }
};

export const catchScoreHash = (score, hash) => {
    const storageKey = getStorageKey(STORAGE_KEY_DYNAMIC_SCORE_HASH);

    clearExpiredSessionStorageKey(storageKey);

    if (score || hash) {
        const dynamicScoreHashUpdated = {};
        dynamicScoreHashUpdated.score = score ? score : '';
        dynamicScoreHashUpdated.hash = hash ? hash : '';
        dynamicScoreHashUpdated.expiration = nowTimestampPlusDays(1);

        sessionStorage.setItem(storageKey, JSON.stringify(dynamicScoreHashUpdated));
    }
};

export const catchUserId = userId => {
    const storageKey = getStorageKey(STORAGE_KEY_DYNAMIC_USER_ID);
    clearExpiredSessionStorageKey(storageKey);

    if (userId) {
        const dynamicUserIdUpdated = {};
        dynamicUserIdUpdated.userId = userId ? userId : '';
        dynamicUserIdUpdated.expiration = nowTimestampPlusDays(1);
        sessionStorage.setItem(storageKey, JSON.stringify(dynamicUserIdUpdated));

        fetchUserInfo(userId);
    }
};

export const catchClickId = clickId => {
    const storageKey = getStorageKey(STORAGE_KEY_DYNAMIC_CLICK_ID);
    clearExpiredSessionStorageKey(storageKey);

    if (clickId) {
        const dynamicClickIdUpdated = {};
        dynamicClickIdUpdated.clickId = clickId ? clickId : '';
        dynamicClickIdUpdated.expiration = nowTimestampPlusDays(1);
        sessionStorage.setItem(storageKey, JSON.stringify(dynamicClickIdUpdated));
    }
};

export const catchSource = source => {
    const storageKey = getStorageKey(STORAGE_KEY_DYNAMIC_SOURCE);

    clearExpiredSessionStorageKey(storageKey);

    if (source) {
        const dynamicSourceUpdated = {};
        dynamicSourceUpdated.source = source ? source : '';
        dynamicSourceUpdated.expiration = nowTimestampPlusDays(1);

        sessionStorage.setItem(storageKey, JSON.stringify(dynamicSourceUpdated));
    }
};

export const getSource = () => {
    const storageKeySource = getStorageKey(STORAGE_KEY_DYNAMIC_SOURCE);
    const dynamicSourceStored = sessionStorage.getItem(storageKeySource)
        ? JSON.parse(sessionStorage.getItem(storageKeySource))
        : {};
    return dynamicSourceStored.source ? dynamicSourceStored.source : null;
};

export const fetchUserInfo = userId => {
    const hash = getHash();
    const score = getFraudScore();

    if (userId) {
        let url = `${API_ROOT}/user/last-ebon-info?userId=${userId}`;
        url = score ? url.concat(`&score=${score}`) : url;
        url = hash ? url.concat(`&hmac=${hash}`) : url;

        fetch(url, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(response =>
                catchUserLastEbonInfo(
                    response.payload.email,
                    response.payload.phoneNumber,
                    response.payload.firstname,
                    response.payload.lastname,
                    response.payload.street,
                    response.payload.postcode,
                    response.payload.city,
                    response.payload.country
                )
            );
    }
};

export const isFailureBankTransferEnabled = () => {
    const storageKey = STORAGE_KEY_FAILURE_BANK_TRANSFER_ENABLED;
    const isFailureBankTransferEnabled = sessionStorage.getItem(storageKey)
        ? sessionStorage.getItem(storageKey)
        : false;
    return isFailureBankTransferEnabled === 'true';
};



// WEBPACK FOOTER //
// ./src/utils/plebicardUtils.js